import type { CountryConfigMap } from '../auth-config-types'

export const defaultConfig: CountryConfigMap = {
	DEFAULT: {
		DEFAULT: {
			mapTenant: '',
			mapAuthority: '',
			mapPolicy: '',
			mapClientId: '',
			mapAuthScopes: [],
			mapApprovedAuthorities: [],
			mapRedirectURI: '',
			mapPostLogoutRedirectURI: '',
			urls: {
				MyAccountProfileURL: '',
				MyAccountRewardsURL: '',
				MyAccountVehicleURL: '',
				MyAccountMissingInfoURL: '',
				NotificationInboxURL: '',
				logoutURL: '',
			},
		},
	},
}
